import { render } from "./RecommendPointRank1.vue?vue&type=template&id=930b6dc0&scoped=true"
import script from "./RecommendPointRank1.vue?vue&type=script&lang=js"
export * from "./RecommendPointRank1.vue?vue&type=script&lang=js"

import "./RecommendPointRank1.vue?vue&type=style&index=0&id=930b6dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930b6dc0"]])

export default __exports__